var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArMemberAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#919191;stroke-miterlimit:10;}.cls-2{fill:#919191;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AR_member_assetAsset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.5,
    cy: 7.5,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.59,4.14a.7.7,0,0,1,.73-.49h.18a.77.77,0,0,1,.72.72L12,10.5a.8.8,0,0,1-1.6.12L9.9,6.75,8.39,9.86a1,1,0,0,1-.89.64,1,1,0,0,1-.88-.67L5.1,6.75l-.46,3.91a.78.78,0,0,1-.86.68.77.77,0,0,1-.73-.8L3.8,4.37a.78.78,0,0,1,.7-.72h.16a.69.69,0,0,1,.73.49L7.5,8.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArMemberAsset);
export default __webpack_public_path__ + "static/media/AR_member_asset.8b26bb66f247f1aaa0eb46b98088dd69.svg";
export { ForwardRef as ReactComponent };